import React, { useState } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";

const Mennyiseg = () => {
    const { order, updateOrder } = useOrder();
    const navigate = useStepNavigate();
    const [loading] = useState(false);

    const [selectedOption, setSelectedOption] = useState("2");
    const [selectedSide, setSelectedSide] = useState("");
    const [showOptions, setShowOptions] = useState(false);



    const updateMennyiseg = (onefootValue, sideValue = null) => {
        let isLeft = null;
        if (onefootValue === 1) {
            isLeft = sideValue === "Bal" ? 1 : sideValue === "Jobb" ? 0 : null;
        } else {
            isLeft = 0;
        }

        updateOrder((prev) => {
            const updatedVenyek = [...prev.venyek];
            if (updatedVenyek[prev.aktivVenyIndex]) {
                updatedVenyek[prev.aktivVenyIndex] = {
                    ...updatedVenyek[prev.aktivVenyIndex],
                    is_onefoot_meas: onefootValue,
                    is_left: isLeft,
                };
            }
            return {
                ...prev,
                venyek: updatedVenyek,
            };
        });
    };

    const handleQuantitySelect = (quantity) => {
        if (quantity === "1") {
            setSelectedOption("1");
            setShowOptions(true);
            setSelectedSide(null);
            updateMennyiseg(1, null);
        } else if (quantity === "2") {
            setSelectedOption("2");
            setShowOptions(false);
            setSelectedSide(null);
            updateMennyiseg(0, null);
        }

        updateOrder((prev) => {
            const updatedVenyek = [...prev.venyek];
            if (updatedVenyek[prev.aktivVenyIndex]) {
                updatedVenyek[prev.aktivVenyIndex] = {
                    ...updatedVenyek[prev.aktivVenyIndex],
                    is_onefoot_meas: quantity === "1" ? 1 : 0,
                    is_left: null,
                };
            }
            return {
                ...prev,
                venyek: updatedVenyek,
            };
        });
    };

    const handleBackClick = () => {
        const specaidtype = order.hmeliorder?.hmeliorder_specaidtype;

        if (specaidtype === 2) {
            navigate("/KozgyogyKerdes");
        } else if (specaidtype === 5) {
            navigate("/EgyediKerdes");
        } else if (specaidtype === 3) {
            navigate("/UzemiKerdes");
        } else if (specaidtype === 4) {
            navigate("/AdatVenyes");
        } else if (specaidtype === 1) {
            navigate("/AdatVenyes");
        }
    };

    const handleSideSelect = (side) => {
        setSelectedSide(side);
        updateMennyiseg(1, side);
    };

    const handleNextPage = async () => {
        if (order.hmeliorder?.hmeliorder_order_type !== 1) {
            navigate("/BetetTartozek");
        } else {
            navigate("/CipoTipus");
        }
    };

    const canProceed = (selectedOption === "1" && selectedSide) || selectedOption === "2";

    return (
        <TablerLayout title="Mennyiség kiválasztása">
            <div className="row justify-content-center">
                <div className="col-md-10 mb-4">
                    <div className="card-body text-center">
                        <div className="mb-4">
                            <h5 className="mb-3 text-start">A vény mindkét cipőt tartalmazza?</h5>
                            <div className="row g-4 justify-content-center">
                                <div className="col-12 col-md-6 d-flex justify-content-center">
                                    <button type="button" className={`btn w-100 py-4 px-3 shadow-sm d-flex flex-column align-items-center fw-bold  ${selectedOption === "1" ? "btn-primary" : "btn-outline-primary"}`} style={{ fontSize: 22 }} onClick={() => handleQuantitySelect("1")}>
                                        Csak az egyiket tartalmazza
                                    </button>
                                </div>
                                <div className="col-12 col-md-6 d-flex justify-content-center">
                                    <button type="button" className={`btn w-100 py-4 px-3 shadow-sm d-flex flex-column align-items-center fw-bold ${selectedOption === "2" ? "btn-primary" : "btn-outline-primary"}`} style={{ fontSize: 22 }} onClick={() => handleQuantitySelect("2")}>
                                        Mindkettőt tartalmazza
                                    </button>
                                </div>
                            </div>
                        </div>
                        {showOptions && (
                            <>
                                <h5 className="mb-3 text-start">Válassza ki, hogy melyik lábra szól a vény:</h5>
                                <div className="d-flex flex-column flex-md-row justify-content-center gap-4">
                                    <button type="button" className={`btn w-100 py-4 px-3 shadow-sm d-flex flex-column align-items-center fw-bold ${selectedSide === "Bal" ? "btn-primary" : "btn-outline-primary"}`} style={{ fontSize: 22 }} onClick={() => handleSideSelect("Bal")}>
                                        Bal
                                    </button>
                                    <button type="button" className={`btn w-100 py-4 px-3 shadow-sm d-flex flex-column align-items-center fw-bold ${selectedSide === "Jobb" ? "btn-primary" : "btn-outline-primary"}`} style={{ fontSize: 22 }} onClick={() => handleSideSelect("Jobb")}>
                                        Jobb
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                    <div className="d-flex justify-content-between mt-4">
                        <StepperNavButton side="left" label="Vissza" onClick={handleBackClick} disabled={loading} />
                        <StepperNavButton side="right" label="Tovább" onClick={handleNextPage} disabled={!canProceed || loading} />
                    </div>
                </div>
            </div>
        </TablerLayout>
    );
};

export default Mennyiseg;
